import * as React from 'react'

import Wait from "../wait";
import CollectService from "../../service/v1/collect";
import AddDodosoPane from "../add/add_dodoso_pane";
import {generateUUID} from "../../ug/uuid";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import PopBig from "../popbig";


export default class MNEPane extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            current_menu: 0,
            current_menu_j: 0,
            questionnaires: [],
            forms: [],
            analysis: [],

            questions: [],

            village_id: 0,
            answers: [],
            dataview: [
                {name: 'Bar Graph', key: 'bar'},
                {name: 'Pie Chart', key: 'pie'},
                {name: 'Table View', key: 'table'}
            ],
            regions: [],
            districts: [],
            wards: [],
            villages: [],
            hamlets: [],
            parent_id: 0,
            parent_hamlet: 0

        }
        this.loadData = this.loadData.bind(this)
        this.loadQuestionnaires = this.loadQuestionnaires.bind(this)
        this.loadQuestionnairesForms = this.loadQuestionnairesForms.bind(this)
        this.handleChanges = this.handleChanges.bind(this)
        this.changeViewAt = this.changeViewAt.bind(this)

    }


    handleChanges = (e) => {
        this.setState({[e.target.name]: e.target.value})
    }

    componentDidMount() {
        this.loadLocalities()
        this.loadQuestionnaires()
    }


    loadQuestionnaires() {
        try {
            Wait.show('Fetching Questions')
            CollectService.fetchQuestions(this.props.project.id, 0, this.props.flag).then(r => {
                try {
                    Wait.dismiss()
                    let result = r.data.results
                    let loc = r.data.localities

                    if (loc.regions.length === 1) {
                        this.setState({
                            parent_id: loc.regions[0].id
                        })
                    }
                    this.setState({
                        questionnaires: result,
                        regions: loc.regions,
                        districts: loc.districts,
                        wards: loc.wards,
                        villages: loc.villages,
                        hamlets: loc.hamlets,
                    })
                    /* if (result.length>0){
                         this.loadQuestionnairesForms(result[0].id)
                     }*/
                } catch (e) {
                    Wait.dismiss()
                    console.log(e)
                }
            })
        } catch (e) {
            console.log(e)
            Wait.dismiss()
        }
    }

    loadQuestionnairesForms(form_id, i = 0) {
        try {
            Wait.show('Fetching Forms....')
            CollectService.fetchQuestionsFormsVerification(this.props.project.id, form_id).then(r => {
                try {
                    Wait.dismiss()
                    console.log(r.data.results)
                    console.log('i : ' + i)
                    this.setState({
                        forms: r.data.results,
                        current_menu_j: i
                    })
                } catch (e) {
                    console.log(e)
                }
            })
        } catch (e) {
            console.log(e)
            Wait.dismiss()
        }
    }

    render() {

        return (<div style={{fontSize: '18px'}}>
            <div className={'row'}>

                <div className={'col col-sm-12'}
                     style={{padding: '8px', background: '#efefef', position: 'sticky', top: 0, zIndex: 2}}>
                    <span style={{fontSize: '16px'}}>
                        <span className={'fa fa-list'} style={{marginRight: '8px'}}/>
                        {this.props.flag === 'analyse' ? 'Analysis' : 'Steps'}
                    </span>

                    <div style={{overflow: 'hidden', display: 'inherit', float: 'right'}}>


                    </div>


                </div>

            </div>


            <div className={'row'}>
                <div className={'col col-sm-3'} style={{height: '100vh', borderRight: '1px dashed #ccc', padding: 0}}>

                    {this.state.questionnaires.map((d, i) => {
                        return (<div key={i}>
                            <div
                                className={i === this.state.current_menu ? 'btn-left-menu btn-left-menu-active' : 'btn-left-menu'}>
                                {d.name}
                            </div>
                            <div style={{width: '100%'}}>
                                {d.forms.map((f, j) => {
                                    return (<div className={'sub-menu'} key={j}
                                                 onClick={() => this.loadQuestionnairesForms(f.id, j)}>
                                        <span
                                            className={j === this.state.current_menu_j ? 'sub-menu-link sub-menu-link-active' : 'sub-menu-link'}
                                            data-hover={f.name}>{f.name}</span>

                                        {/*<span className={'fa fa-plus'} style={{float:'right',color:'#0a0',fontWeight:'bold',fontSize:'18px'}} title={'Add New'}/>*/}
                                    </div>)
                                })}
                            </div>
                        </div>)
                    })}
                </div>
                <div className={'col col-sm-9'} style={{padding: 0, overflowX: 'hidden'}}>


                    <div style={{padding: '8px', overflowY: 'auto', height: '83vh', zIndex: 1}}>

                        {this.props.flag !== 'analyse' ? this.state.forms.map((d, i) => {
                            return (<div key={i} style={{marginBottom: '24px', width: '100%', float: 'left'}}>
                                <div style={{
                                    fontSize: '20px',
                                    color: "darkcyan",
                                    background: 'linear-gradient(#fff,#ccc)',
                                    marginTop: '8px',
                                    borderTop: '1px solid #ccc',
                                    padding: '8px'
                                }}>
                                    <span className={'fa fa-question-circle'}/>{d.name}
                                </div>
                                <div style={{overflowX: 'auto'}}>
                                    <div className={'col col-sm-12'}>
                                        <h1> Total Score : <span style={{color: '#080'}}>88.8%</span></h1>
                                    </div>
                                    <table className={'tb'} style={{width: '100%'}}>
                                        <thead>
                                        <tr>
                                            <th>Action</th>
                                            <th>Means Of Verification</th>
                                            <th>Assessment Performance</th>
                                        </tr>
                                        </thead>
                                        <tbody>

                                        {d.form_fields.map((q, j) => {
                                            if (q.id > 1) {
                                                return (<>
                                                    <tr style={{verticalAlign: 'top'}} key={j}>
                                                        <td style={{
                                                            maxWidth: '300px',
                                                            whiteSpace: 'pre-line',
                                                            width: 'fit-content'
                                                        }} rowspan={q.options.split(',').length + 1}>

                                                            <div style={{
                                                                wordBreak: 'break-word',
                                                                whiteSpace: 'pre',
                                                                width: '100%'
                                                            }}>
                                                                {q.form_field}
                                                            </div>

                                                        </td>
                                                    </tr>
                                                    {q.options.split(',').map((o, k) => {
                                                        return (<tr key={k}>
                                                            <td>
                                                                <div key={k}>{o}</div>
                                                            </td>
                                                            <td>
                                                                <input defaultValue={1.8}/>%
                                                            </td>
                                                        </tr>)
                                                    })}


                                                </>)
                                            }
                                        })}


                                        </tbody>
                                    </table>
                                    <div style={{padding: '8px'}}>
                                        <button className={'btn error'}>
                                            <span className={'fa fa-print'}/>Export
                                        </button>
                                    </div>
                                </div>
                            </div>)
                        }) : this.state.analysis.map((d, i) => {
                            return (<div className={'ucard'} key={i}
                                         style={{marginBottom: '24px', width: '97%', float: 'left'}}>


                                <div className={'row'}>
                                    <div className={'col col-sm-10'} style={{borderRight: '1px dashed #888'}}>
                                        <div id={'bar_' + d.id + '_' + i}>
                                            <HighchartsReact
                                                highcharts={Highcharts}
                                                options={this.loadBarChart(d)}
                                            />
                                        </div>

                                        <div id={'pie_' + d.id + '_' + i} style={{display: 'none'}}>
                                            <HighchartsReact
                                                highcharts={Highcharts}
                                                options={this.loadPieChart(d)}
                                            />
                                        </div>
                                        <div id={'table_' + d.id + '_' + i} style={{display: 'none'}}>
                                            <div style={{fontWeight: 'bold', fontSize: '20px', marginBottom: '16px'}}>
                                                {d.name}
                                            </div>
                                            <table className={'tb'} style={{width: '100%'}}>
                                                <thead>
                                                <tr>
                                                    <th>DataSet</th>
                                                    {d.categories.map((c, k) => {
                                                        return (<th key={k}>{c}</th>)
                                                    })}
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {d.series.map((s, l) => {
                                                    return (<tr key={l}>
                                                        <td>{s.name}</td>
                                                        {s.data.map((c, m) => {
                                                            return (<td key={m}>{c}</td>)
                                                        })}
                                                    </tr>)
                                                })}
                                                </tbody>
                                            </table>
                                        </div>

                                        <div style={{padding: '8px'}}>
                                            <button className={'btn submit'}>
                                                <span className={'fa fa-print'}/>Export
                                            </button>
                                        </div>
                                    </div>

                                    <div className={'col col-sm-2'}
                                         style={{height: '100%', position: "sticky", top: 0}}>

                                        {this.state.dataview.map((v, j) => {
                                            let id = 'btn_' + i + '_' + j
                                            return (<div onClick={() => this.changeViewAt(d, v, i, j)}
                                                         style={{fontWeight: 'bold'}} key={j} id={id}
                                                         className={j === 0 ? 'btn-left-menu btn-left-menu-active' : 'btn-left-menu'}>
                                                <span className={'fa fa-angle-double-left'}/>{v.name}
                                            </div>)
                                        })}
                                    </div>

                                </div>
                            </div>)
                        })}

                    </div>

                </div>
            </div>

        </div>)
    }

    changeViewAt(d, v, i, j) {
        this.state.analysis.map((dd, ii) => {
            this.state.dataview.map((ss, jj) => {
                document.getElementById('btn_' + ii + '_' + jj).style.background = 'inherit'
                document.getElementById('btn_' + ii + '_' + jj).style.fontWeight = 'inherit'
                document.getElementById('btn_' + ii + '_' + jj).style.color = 'inherit'
            })
        })
        document.getElementById('btn_' + i + '_' + j).style.background = '#484848'
        document.getElementById('btn_' + i + '_' + j).style.fontWeight = 'bold'
        document.getElementById('btn_' + i + '_' + j).style.color = '#fff'


        switch (v.key) {
            case "pie":
                document.getElementById('pie_' + d.id + '_' + i).style.display = 'inherit'
                document.getElementById('bar_' + d.id + '_' + i).style.display = 'none'
                document.getElementById('table_' + d.id + '_' + i).style.display = 'none'
                break
            case "bar":
                document.getElementById('bar_' + d.id + '_' + i).style.display = 'inherit'
                document.getElementById('pie_' + d.id + '_' + i).style.display = 'none'
                document.getElementById('table_' + d.id + '_' + i).style.display = 'none'
                break
            case "table":
                document.getElementById('table_' + d.id + '_' + i).style.display = 'inherit'
                document.getElementById('pie_' + d.id + '_' + i).style.display = 'none'
                document.getElementById('bar_' + d.id + '_' + i).style.display = 'none'
                break
        }
    }

    loadPieChart(d) {
        //console.log(d)
        return {
            chart: {
                renderTo: 'high-chart-donut0',
                type: 'pie'
            },
            title: {
                text: d.name,
            },
            yAxis: {
                title: {
                    text: 'Total percent market share'
                }
            },
            plotOptions: {
                pie: {
                    shadow: true
                }
            },
            tooltip: {
                formatter: function () {
                    return '<b>' + this.point.name + '</b>: ' + this.y + ' %';
                }
            },
            series: [{
                name: 'LandUse',
                data: d.data,//[["Agriculture", 40], ["Settlement", 30], ["Forest", 10], ["Investment", 15], ["Reserve", 5]],
                size: '100%',
                innerSize: '10%',
                showInLegend: true,
                dataLabels: {
                    enabled: true
                }
            }]
        }

    }

    loadBarChart(d) {
        //console.log(d)
        return {
            chart: {
                type: 'column'
            },

            title: {
                text: d.name
            },

            subtitle: {
                text: ''
            },

            yAxis: {
                title: {
                    text: 'No. of Project'
                }
            },

            xAxis: {
                categories: d.categories,//['Selemi', 'Buduba'],
                crosshair: true
            },

            legend: {
                layout: 'vertical',
                align: 'right',
                verticalAlign: 'middle'
            },
            series: d.series,
            /*series: [{
                    name: 'Ndio',
                    data: [631, 727]
                }, {
                    name: 'Hapana',
                    data: [814, 841]
                }],*/




            responsive: {
                rules: [{
                    condition: {
                        maxWidth: 500
                    },
                    chartOptions: {
                        legend: {
                            layout: 'horizontal',
                            align: 'center',
                            verticalAlign: 'bottom'
                        }
                    }
                }]
            }
        }
    }

    loadData(stage = this.props.stage) {
        /*try {
            Wait.show('Fetching Draft Data....')
            ReadService.fetchCCRDraftData(this.props.project.id,this.state.village_id,this.props.flag).then(r=>{
                Wait.dismiss()
                try{
                    console.log(r.data)
                    this.setState({
                        questions:r.data.questions,
                        answers:r.data.answers
                    })
                }catch (e) {
                    console.log(e)
                }

            })
        }catch (e) {

        }*/
    }

    loadLocalities() {
        /* try{
             Wait.show('Loading Villages...')
             ReadService.fetchLocalitiesByProject(this.props.project.id).then(r=>{
                 try {
                     let data = r.data.results

                     console.log(data)
                     this.setState({
                         villages:data,
                         village_id:data[0].id
                     })

                     setTimeout(()=>this.loadData(),500)
                 }catch (e) {
                     console.log(e)
                 }


             })
         }catch (e) {
             console.log(e)
         }*/

    }


    downloadSHP() {


    }
}
